export enum PartnerTimeRangeEnum {
    All = 0,
    LastYear = 1,
    Last5Years = 2,
    Last10Years = 3,
    Custom = 4
}